import { Directive, OnDestroy, OnInit, TemplateRef, inject } from '@angular/core';
import { BoschUiDialog } from '../bosch-ui-dialog.service';
import { debounceTime, filter, Subject, takeUntil } from 'rxjs';

@Directive({
  selector: '[boschUiDialogTitle]',
})
export class BoschUiDialogTitleDirective implements OnInit, OnDestroy {
  private readonly template = inject(TemplateRef<unknown>);
  private readonly dialogService = inject(BoschUiDialog);

  private _unsubscribe$ = new Subject<void>();

  constructor() {
    this.dialogService.hasTitle$.next(true);
  }

  ngOnInit(): void {
    // TODO: find more elegant solution
    this.dialogService.hasTitle$.pipe(filter(Boolean), debounceTime(0), takeUntil(this._unsubscribe$)).subscribe(() => {
      const dialog = this.dialogService.dialogRef?.instance;

      if (dialog && dialog.title) {
        dialog.title.createEmbeddedView(this.template).detectChanges();
      }
    });
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this.dialogService.hasTitle$.next(false);
  }
}
